import { Category, EventName, detectPlatform } from './analyticsCore';
import {
  initMixpanel,
  setMixpanelUserId,
  setMixpanelUserProperties,
  trackMixpanelEvent,
} from './mixpanelClient';

export type { Category, EventName };

let isMixpanelEnabled = false;

interface AnalyticsConfig {
  mixpanel?: {
    token?: string;
  };
  userId?: number; // 공통 사용자 ID
}

/**
 * 모든 활성화된 분석 서비스를 초기화합니다.
 *
 * @param config 분석 클라이언트별 API 키와 공통 사용자 ID를 포함하는 설정 객체
 */
export const initAnalytics = (config: AnalyticsConfig) => {
  const { userId } = config;
  isMixpanelEnabled = !!config.mixpanel?.token;

  if (isMixpanelEnabled) {
    if (config.mixpanel?.token) {
      initMixpanel(config.mixpanel.token, userId);
    } else {
      console.warn(
        'Mixpanel이 활성화되었으나, Mixpanel 토큰이 제공되지 않았습니다.'
      );
    }
  }
};

/**
 * 모든 활성화된 분석 서비스에 이벤트를 전송합니다.
 * @param category 이벤트 카테고리
 * @param eventName 이벤트 이름
 * @param properties 추가 속성 (선택 사항)
 */
export const trackEvent = <T extends Category>(
  category: T,
  eventName: EventName<T>,
  properties?: Record<string, unknown>
) => {
  const platform = detectPlatform();
  const eventProperties = {
    ...properties,
    category,
    platform,
  };

  if (isMixpanelEnabled) {
    trackMixpanelEvent(eventName, eventProperties);
  }
};

/**
 * 모든 활성화된 분석 서비스의 사용자 ID를 설정합니다.
 * @param userId 설정할 사용자 ID
 */
export const setAnalyticsUserId = (userId: number) => {
  if (isMixpanelEnabled) {
    setMixpanelUserId(userId);
  }
};

/**
 * 사용자 프로필 속성을 설정합니다.
 * @param properties 설정할 사용자 프로필 속성
 */
export const setUserProperties = (properties: Record<string, unknown>) => {
  if (isMixpanelEnabled) {
    setMixpanelUserProperties(properties);
  }
};
